import { oc } from '@orpc/contract'
import { z } from 'zod'
import { localeSchema } from '../locale'

export const authUserSchema = z.object({
  id: z.string().min(1),
  email: z.string().email(),
  name: z.string().nullable(),
  phone: z.string().nullable(),
  avatarUrl: z.string().nullable(),
  /** UI language; null until the user picks one. */
  locale: localeSchema.nullable(),
  createdAt: z.string(),
})

export const requestOtpContract = oc
  .input(
    z.object({
      email: z.string().trim().email(),
    })
  )
  .output(
    z.object({
      challengeId: z.string().min(1),
      resendAvailableAt: z.string(),
      /** Local dev only (`DEV_SHOW_OTP=1`, never on a deploy — worker/auth/dev-otp.ts). */
      devCode: z
        .string()
        .regex(/^\d{6}$/)
        .optional(),
    })
  )

export const verifyOtpContract = oc
  .input(
    z.object({
      challengeId: z.string().min(1),
      code: z.string().regex(/^\d{6}$/),
    })
  )
  .output(
    z.object({
      user: authUserSchema,
      session: z.object({
        expiresAt: z.string(),
      }),
    })
  )

export const resendOtpContract = oc
  .input(
    z.object({
      challengeId: z.string().min(1),
    })
  )
  .output(
    z.object({
      resendAvailableAt: z.string(),
      /** Local dev only (`DEV_SHOW_OTP=1`, never on a deploy — worker/auth/dev-otp.ts). */
      devCode: z
        .string()
        .regex(/^\d{6}$/)
        .optional(),
    })
  )

export const logoutContract = oc.input(z.object({}).optional()).output(
  z.object({
    ok: z.literal(true),
  })
)

export const authProvidersContract = oc.input(z.object({}).optional()).output(
  z.object({
    emailOtp: z.literal(true),
    google: z.boolean(),
    microsoft: z.boolean(),
  })
)
